const ClearRecordedAudio = ({
  setRecordedAudioFile,
  recordedAudioUrl,
  setRecordedAudioUrl,
  setRecordingTime,
}) => {
  setRecordedAudioFile(null)
  if (recordedAudioUrl) {
    try { URL.revokeObjectURL(recordedAudioUrl) } catch {}
  }
  setRecordedAudioUrl("")
  setRecordingTime(0)
}

export default ClearRecordedAudio